import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function ChooseMultiGroupAnalyse(props) {
  const [clef, setClef] = useState("");
  const [name, setName] = useState("");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, handleMultiGroupChoice, handleChooseMultiGroupLaunch, multigroupmode, selectioncount } = props;

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleClefChange = (e) => {
    setClef(e.target.value);
  };

  const classes = useStyles();

  const choice = [{ id: 'comparaison', name: 'Comparer les groupes' }, { id: 'aggregation', name: 'Aggréger les groupes' }];
  const choicetoomany = [{ id: 'aggregation', name: 'Aggréger les groupes' }];

  return (
    <Card>
      <CardHeader color="success" icon>

      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
                <CustomSelect
                  inputTitle={'Choix du fonctionnement multi-groupes'}
                  selectValue={multigroupmode}
                  handleSelectValueChange={handleMultiGroupChoice}
                  data={selectioncount > 10 ? choicetoomany : choice}
                />
              <div style={{margin: '1.1rem 0.5rem 0rem'}}>
                <Button color={"success"} onClick={handleChooseMultiGroupLaunch}>
                  Lancer l'analyse
                </Button>
              </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
}

export default ChooseMultiGroupAnalyse;
